import { RESTSerializer } from '@warp-drive/legacy/serializer/rest';

export default class Base extends RESTSerializer {
  payloadKeyFromModelName(modelName) {
    return super.payloadKeyFromModelName(modelName).replace(/^teRito\//, '');
  }

  modelNameFromPayloadKey(key) {
    return super.modelNameFromPayloadKey('teRito/' + key);
  }
}
